import type { ColumnDef } from "@tanstack/react-table";
import type { ChangelogEntryListItem } from "@/types/changelog";
import { CategoryBadge } from "./category-badge";
import { ChangelogStatusBadge } from "./changelog-status-badge";
import { ChangelogActions, type ChangelogAction } from "./changelog-actions";
import { formatDate } from "@/lib/format";

export function getChangelogColumns(
  onAction: (
    entry: ChangelogEntryListItem,
    action: ChangelogAction,
  ) => void,
): ColumnDef<ChangelogEntryListItem>[] {
  return [
    {
      accessorKey: "title",
      header: "제목",
      cell: ({ row }) => {
        const title = row.original.title.ko;
        return (
          <div
            className="max-w-[300px] truncate text-sm font-medium"
            title={title}
          >
            {title}
          </div>
        );
      },
    },
    {
      accessorKey: "categories",
      header: "카테고리",
      cell: ({ row }) => (
        <div className="flex flex-wrap gap-1">
          {row.original.categories.map((cat) => (
            <CategoryBadge
              key={cat._id}
              name={cat.name.ko}
              color={cat.color}
            />
          ))}
        </div>
      ),
    },
    {
      accessorKey: "status",
      header: "상태",
      cell: ({ row }) => <ChangelogStatusBadge status={row.original.status} />,
    },
    {
      accessorKey: "publishedAt",
      header: "발행일",
      cell: ({ row }) => (
        <div className="whitespace-nowrap text-sm">
          {formatDate(row.original.publishedAt, { format: "short" })}
        </div>
      ),
    },
    {
      accessorKey: "createdAt",
      header: "생성일",
      cell: ({ row }) => (
        <div className="whitespace-nowrap text-sm">
          {formatDate(row.original.createdAt, { format: "short" })}
        </div>
      ),
    },
    {
      id: "actions",
      header: "작업",
      cell: ({ row }) => (
        <ChangelogActions entry={row.original} onAction={onAction} />
      ),
    },
  ];
}
